import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";
import i18n from "../../i18n";

const API_URL = `${process.env.REACT_APP_API_URL}/user`;

// =========================
//  GET ALL USERS
// =========================
export const getAllUsers = createAsyncThunk(
  "users/getAll",
  async ({ page = 1, limit = 10, search = "", role }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      // console.log(role);
      const res = await axios.get(
        `${API_URL}?page=${page}&limit=${limit}${
          search ? `&search=${search}` : ""
        }${role ? `&role=${role}` : ""}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch users");
    }
  },
);

// =========================
//  UPDATE USER
// =========================
export const updateUser = createAsyncThunk(
  "users/update",
  async ({ id, updatedData }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.put(`${API_URL}/${id}`, updatedData, {
        headers: {
          Authorization: token,
        },
      });
      toast.success(i18n.t("common.userUpdated"));
      return res.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || "Failed to update user");
    }
  },
);

// =========================
//  DELETE USER
// =========================
export const deleteUser = createAsyncThunk(
  "users/delete",
  async (id, { rejectWithValue }) => {
    try {
      // console.log(id);
      const token = getAuthToken();
      // console.log(token);
      const res = await axios.delete(`${API_URL}/${id}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      // toast.success("User deleted successfully");
      return id;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || "Failed to delete user");
    }
  },
);

// =========================
//  BLOCK / UNBLOCK USER
// =========================
export const blockUser = createAsyncThunk(
  "users/block",
  async ({ id }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.patch(
        `${API_URL}/toggle-block/${id}`,
        {},
        {
          headers: {
            Authorization: `${token}`,
          },
        },
      );
      return { id };
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || "Failed to block user");
    }
  },
);

// =========================
//  GET USER CODE
// =========================
export const getUserByCode = createAsyncThunk(
  "users/getByCode",
  async (code, { rejectWithValue }) => {
    try {
      const token = getAuthToken();

      const res = await axios.get(`${API_URL}/${code}/code`, {
        headers: {
          Authorization: token,
        },
      });

      return res.data;
    } catch (error) {
      // handleApiError(error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch user profile",
      );
    }
  },
);
